import axios from "axios";

// Libs
import { getTokenFromLocalStorage } from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Notifications
import {addNotification} from "../notifications/notifications-actions";
import i18n from "../i18n";
import FileSaver from 'file-saver';

// Constants
export const FETCH_DOCUMENTATION_REQUEST = "FETCH_DOCUMENTATION_REQUEST";
export const FETCH_DOCUMENTATION_SUCCESS = "FETCH_DOCUMENTATION_SUCCESS";
export const FETCH_DOCUMENTATION_ERROR = "FETCH_DOCUMENTATION_ERROR";
export const DELETE_DOCUMENTATION_REQUEST = "DELETE_DOCUMENTATION_REQUEST";
export const DELETE_DOCUMENTATION_SUCCESS = "DELETE_DOCUMENTATION_SUCCESS";
export const DELETE_DOCUMENTATION_ERROR = "DELETE_DOCUMENTATION_ERROR";
export const CREATE_DOCUMENTATION_REQUEST = "CREATE_DOCUMENTATION_REQUEST";
export const CREATE_DOCUMENTATION_SUCCESS = "CREATE_DOCUMENTATION_SUCCESS";
export const CREATE_DOCUMENTATION_ERROR = "CREATE_DOCUMENTATION_ERROR";
export const UPDATE_DOCUMENTATION_REQUEST = "UPDATE_DOCUMENTATION_REQUEST";
export const UPDATE_DOCUMENTATION_SUCCESS = "UPDATE_DOCUMENTATION_SUCCESS";
export const UPDATE_DOCUMENTATION_ERROR = "UPDATE_DOCUMENTATION_ERROR";

export const readDocumentation = (filters = {}) => {
    return async (dispatch) => {
        try {
            dispatch(fetchDocumentationRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post(`/api/files`, filters, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchDocumentationSuccess, fetchDocumentationError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchDocumentationError));
        }
    };
};

const fetchDocumentationRequest = () => {
    return {
        type: FETCH_DOCUMENTATION_REQUEST
    };
};

const fetchDocumentationSuccess = (payload) => {
    return {
        type: FETCH_DOCUMENTATION_SUCCESS,
        payload
    };
};

const fetchDocumentationError = (errorMessage) => {
    return {
        type: FETCH_DOCUMENTATION_ERROR,
        errorMessage
    };
};

export const deleteDocumentation = (file) => {
    return async (dispatch) => {
        try {
            dispatch(deleteDocumentationRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.delete(`/api/files/delete/${file}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteDocumentationSuccess, deleteDocumentationError));

            // Create notification for delete document success
            dispatch(addNotification({
                message: i18n.t("clients:toaster.success.deleteDocument"),
                color: 'green',
                icon: 'tick'
            }));

        } catch (err) {
            dispatch(utilsLib.response(err, deleteDocumentationError));

            // Create notification for delete document error
            dispatch(addNotification({
                message: i18n.t("clients:toaster.error.deleteDocument"),
                color: 'red',
                icon: 'tick'
            }));
        }
    };
};

const deleteDocumentationRequest = () => {
    return {
        type: DELETE_DOCUMENTATION_REQUEST
    };
};

const deleteDocumentationSuccess = (payload) => {
    return {
        type: DELETE_DOCUMENTATION_SUCCESS,
        payload
    };
};

const deleteDocumentationError = (errorMessage) => {
    return {
        type: DELETE_DOCUMENTATION_ERROR,
        errorMessage
    };
};

// Download file
function saveFile(res, fileName) {
    FileSaver.saveAs(res.data, fileName);
}

export const downloadDocumentation = (file, fileName) => {
    return async () => {
        try {
            const token = getTokenFromLocalStorage();

            const res = await axios.get(`/api/files/download/${file}`, { headers: { 'Authorization': 'Bearer ' + token }, responseType: 'blob' });
                
            saveFile(res, fileName);
        } catch (err) {
            return err
        }
    };
};

export const createDocumentation = (data) => {
    return async (dispatch) => {
        try {
            dispatch(createDocumentationRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post(`/api/files/create`, data , { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createDocumentationSuccess, createDocumentationError));

            // Create notification for create document success
            dispatch(addNotification({
                message: i18n.t("clients:toaster.success.createDocument"),
                color: 'green',
                icon: 'tick'
            }));

        } catch (err) {
            dispatch(utilsLib.response(err, createDocumentationError));

            // Create notification for create document error
            dispatch(addNotification({
                message: i18n.t("clients:toaster.error.createDocument"),
                color: 'red',
                icon: 'tick'
            }));
        }
    };
};

const createDocumentationRequest = () => {
    return {
        type: CREATE_DOCUMENTATION_REQUEST
    };
};

const createDocumentationSuccess = (payload) => {
    return {
        type: CREATE_DOCUMENTATION_SUCCESS,
        payload
    };
};

const createDocumentationError = (errorMessage) => {
    return {
        type: CREATE_DOCUMENTATION_ERROR,
        errorMessage
    };
};

export const updateDocumentation = (fileId, data) => {
    return async (dispatch) => {
        try {
            dispatch(updateDocumentationRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post(`/api/files/update/${fileId}`, data , { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateDocumentationSuccess, updateDocumentationError));

            // Create notification for update document success
            dispatch(addNotification({
                message: i18n.t("clients:toaster.success.updateDocument"),
                color: 'green',
                icon: 'tick'
            }));

        } catch (err) {
            dispatch(utilsLib.response(err, updateDocumentationError));

            // Create notification for update document error
            dispatch(addNotification({
                message: i18n.t("clients:toaster.error.updateDocument"),
                color: 'red',
                icon: 'tick'
            }));
        }
    };
};

const updateDocumentationRequest = () => {
    return {
        type: UPDATE_DOCUMENTATION_REQUEST
    };
};

const updateDocumentationSuccess = (payload) => {
    return {
        type: UPDATE_DOCUMENTATION_SUCCESS,
        payload
    };
};

const updateDocumentationError = (errorMessage) => {
    return {
        type: UPDATE_DOCUMENTATION_ERROR,
        errorMessage
    };
};